<h3><a ng-click="viewDetails($event, item)">{{item.name}} <span ng-if="!item.active">{{"centuriList.inactive"|translate}}</span></a></h3>
<span ng-show="item.description && item.description.length > 0">{{item.description}}</span>